"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMoveToDepartmentCtrl = void 0;
const core_api_1 = require("@ikegps/core-api");
const i18n_1 = require("../../i18n");
const index_1 = require("../../services/index");
const page_state_1 = require("../../state/page.state");
const collection_move_modal_1 = require("../collection.move.modal/collection.move.modal");
exports.CollectionMoveToDepartmentCtrl = {
    canMove() {
        if (!index_1.Services.Token.has(core_api_1.IkeToken.TAG_JOB_UPDATE)
            || !(index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_MOVE) || index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE))) {
            return false;
        }
        return index_1.Services.Department.moveableDepartments().length > 0;
    },
    showMoveModal() {
        const collections = page_state_1.CurrentState.Tag.collections;
        const modal = new collection_move_modal_1.CollectionMoveToDepartmentModal({
            title: i18n_1.T.COLLECTION_MOVE_TITLE,
            confirm: i18n_1.T.COLLECTION_MOVE,
            success: {
                key: i18n_1.T.COLLECTION_MOVE_SUCCESS,
                attrs: {
                    count: collections.length
                }
            }
        }, collections);
        modal.open();
    }
};
//# sourceMappingURL=collection.move.department.ctrl.js.map